export const VOY_TOKEN_ADDRESS = "0x22F43a8FF47C05B1fFA449eC6d2810ABD190d19F";
export const VOY_FACTORY_ADDRESS = "0xc56432Cb576bBE6861D2F34168D9ddE41B48af69";
export const VOY_TREASURE_HUNT_ADDRESS = "0x4AA456f0E2c339564C001c5e9f5E2FF04775156F";

// export const API_URL = 'http://localhost:3000/dev/'
export const API_URL = 'https://api.gasswap.io/';
// BING KEY Ak9JQwlH5BwtMCcviUkQJ_LEXncKwPwJDlUvaTLOWdaZSg7cz8AobFImAk7wPTD6